import duplicateMessageComponent from './duplicate_message.component';

let duplicateMessageModule = angular.module('duplicateMessage', [])

  .component('duplicateMessage', duplicateMessageComponent)

  .name;

export default duplicateMessageModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/duplicate_message/index.js